import { Button as AriaButton } from 'react-aria-components';
import { GripVertical } from 'lucide-react';
import { buttonVariants } from 'v5/design-system/Button';
import { cn } from 'v5/platform/dom/cn';

export type CollectionDragHandleProps = {
  label: string;
  className?: string;
  enabled?: boolean;
  hidden?: boolean;
  dimmed?: boolean;
};

/** RAC `slot="drag"` affordance shared by sortable collection rows. */
export function CollectionDragHandle({
  label,
  className,
  enabled = true,
  hidden = false,
  dimmed = false
}: CollectionDragHandleProps) {
  return (
    <AriaButton
      slot="drag"
      aria-disabled={!enabled || undefined}
      aria-hidden={hidden || undefined}
      aria-label={label}
      className={cn(
        buttonVariants({ variant: 'ghost', size: 'xs', layout: 'icon' }),
        'size-4 shrink-0 min-h-0 min-w-0 p-0',
        hidden && 'invisible pointer-events-none',
        enabled &&
          !dimmed &&
          'cursor-grab active:cursor-grabbing touch-none select-none',
        enabled && dimmed && 'opacity-15',
        !enabled && 'cursor-default',
        className
      )}
    >
      <GripVertical className="size-4" />
    </AriaButton>
  );
}
